// extracted by mini-css-extract-plugin
module.exports = {"chevronLeftContainer":"styles_chevronLeftContainer__3Jl5j","chevronLeftLink":"styles_chevronLeftLink___PjJg"};